if (!customElements.get('annarita-hero')) {
  customElements.define('annarita-hero', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || this.bound) return;
      this.bound = true;
      this.video.muted = true;
      this.video.loop = true;
      this.video.controls = false;
      this.video.setAttribute('playsinline', '');
      this.video.setAttribute('aria-hidden', 'true');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = true;
      this.onMotion = () => {
        if (this.motion.matches || navigator.connection?.saveData || document.hidden || !this.visible) {
          this.video.autoplay = false;
          this.video.pause();
        } else {
          this.video.autoplay = true;
          this.video.play().catch(() => {});
        }
      };
      this.motion.addEventListener('change', this.onMotion);
      document.addEventListener('visibilitychange', this.onMotion);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.onMotion();
        }, { threshold: 0.01 });
        this.observer.observe(this);
      }
      this.onMotion();
    }
    disconnectedCallback() {
      this.video?.pause();
      this.motion?.removeEventListener('change', this.onMotion);
      document.removeEventListener('visibilitychange', this.onMotion);
      this.observer?.disconnect();
      this.bound = false;
    }
  });
}
